module.exports = __webpack_public_path__ + "img/alibaba-cloud.3fcf94e1.png";